const constants = require('@/util/constants')
require('./config')

/**
 * 查询
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryAutoReply(page, size, successcb, failedcb) {
    axios.get('/api/v1/autoreply/query', {
        params: {
            'page': page,
            'size': size,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 设置 自动回复内容
 */
// export function updateAutoReply (autoReply, autoReplyContent, successcb, failedcb) {
//     axios.post('/api/v2/user/update/autoReply', {
//         autoReply,
//         autoReplyContent
//     }).then(response => {
//         successcb(response.data)
//     }).catch(error => {
//         failedcb(error)
//     })
// }

export function updateAutoReply2(autoReply, content, imageUrl, successcb, failedcb) {
    axios.post('/api/v1/autoreply/update', {
        autoReply,
        content,
        imageUrl
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 
 * @param {*} aid 
 * @param {*} autoReply 
 * @param {*} content 
 * @param {*} imageUrl 
 * @param {*} successcb 
 * @param {*} failedcb 
 */
export function updateAutoReplyHistory(aid, autoReply, content, imageUrl, successcb, failedcb) {
    axios.post('/api/v1/autoreply/update/history', {
        aid,
        autoReply,
        content,
        imageUrl
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 
 * @param {*} aid 
 * @param {*} successcb 
 * @param {*} failedcb 
 */
export function deleteAutoReply(aid, successcb, failedcb) {
    axios.post('/api/v1/autoreply/delete', {
        aid,
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
